import React from "react";
import { observer } from "mobx-react";
import announcementStore from "../../stores/AnnouncementStore";
import AnnouncementPopup from "./AnnouncementPopup";

const AnnouncementHub = observer(() => {
  console.log("[AnnouncementHub] render - items:", announcementStore.items.length, "loading:", announcementStore.loading);

  if (!announcementStore.items.length) {
    console.log("[AnnouncementHub] sem items, não renderiza popups");
    return null;
  }

  console.log("[AnnouncementHub] renderizando", announcementStore.items.length, "popups");

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    >
      {announcementStore.items.map((item) => (
        <AnnouncementPopup key={item.announcementId} item={item} />
      ))}
    </div>
  );
});

export default AnnouncementHub;
